import {
  useCheckVersionUpdate,
  VersionUpdateCheckParams,
} from './useCheckVersionUpdate';
import { useEffect } from 'react';

export const useReloadOnVersionUpdate = (
  checkParams: VersionUpdateCheckParams,
) => {
  const { isVersionUpdated } = useCheckVersionUpdate(checkParams);
  useEffect(() => {
    if (isVersionUpdated) {
      window.location.reload();
    }
  }, [isVersionUpdated]);
};
